import { useCallback, useState } from 'react';
import { Button, DialogContent, TextField } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';

export interface SaveAsDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (value: string) => void;
}

function SaveAsDialog({ onClose, onSave, open }: SaveAsDialogProps) {
    const [projectName, setProjectName] = useState("");
    const [changed, setChanged] = useState<boolean>(false);

    const handleClose = () => {
        setProjectName("");
        onClose();
    };

    const handleSave = () => {
        onSave(projectName);
        handleClose();
    };

    const sendOnChanged = useCallback(() => {
        if (!changed)
            return

        setChanged(false);
    }, [setChanged, changed]);

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>Save as...</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="project-name"
                    name=""
                    label="New Project Name"
                    type="text"
                    fullWidth
                    variant="standard"
                    onChange={(e) => { setChanged(true); setProjectName(e.target.value) }}
                    onBlur={(e) => sendOnChanged()}
                    onKeyDownCapture={(e) => {
                        if (e.key !== "Enter")
                            return

                        sendOnChanged();
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSave} autoFocus disabled={projectName === ""}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export default SaveAsDialog;
